import { useEffect, useState } from "react";
import { getUserChannels } from "../../../services/vod/vod.service";

export default function Channels({ onChannelSelect }) {
  const [channels, setChannels] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    getUserChannels()
      .then((res) => {
        setLoading(false);
        const list = res?.data?.data;
        if (Array.isArray(list) && list.length > 0) {
          setChannels(list);
        }
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div>
      {/* Channels list */}
      {!loading && Array.isArray(channels) && channels.length > 0 && (
        <div>
          {channels.map((el) => (
            <div key={el.id} className="channels-row">
              <div className="channel-label">
                <div>کانال</div>
                <div>تعداد ویدئو : {el.videos_count}</div>
              </div>
              <h2>{el.title}</h2>
              <button
                className="watch-videos-button"
                onClick={() => onChannelSelect(el)}
              >
                مشاهده ویدئو ها
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Loading state */}
      {loading && (
        <div className="loading-wrapper">در حال بارگزاری اطلاعات</div>
      )}
    </div>
  );
}
